function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import { BackButton } from "../../Layout";
import { Icon, ToggleButton } from "../../UI";
import { actions, Translate, I18NLink, t } from "./..";
import { SelectFileButton } from "../../App/SelectFileButton";
import {
prepareFormValues,
prepareTranslationsToSave } from "../actions/translationsFormActions";



const importButton = (action) => /*#__PURE__*/
_jsx(SelectFileButton, { onFileImported: action }, void 0, /*#__PURE__*/
_jsx("button", { type: "button", className: "btn btn-default import-template" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "upload" }), /*#__PURE__*/
_jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Import"))));





const mapStateToProps = (state) => ({
  translations: state.translations
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{
  saveTranslations: actions.saveTranslations,
  importTranslations: actions.importTranslations
},
dispatch);


const connector = connect(mapStateToProps, mapDispatchToProps);



const EditTranslationsFormComponent = ({
  context,
  translations,
  saveTranslations,
  importTranslations
}) => {
  const [showUntranslatedOnly, setShowUntranslatedOnly] = useState(false);

  const { contextLabel, formData, contextTranslations } = prepareFormValues(translations, context);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: { formData },
    mode: 'onSubmit'
  });

  const submit = (values) => {
    const translationsToSave = prepareTranslationsToSave(contextTranslations, values.formData);
    saveTranslations(translationsToSave);
  };

  const noUntranslatedTerms = !formData.find((data) => data.hasUntranslatedValues);

  return /*#__PURE__*/(
    _jsx("div", { className: "EditTranslationForm" }, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submit) }, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "context" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Translations"), /*#__PURE__*/
    _jsx(Icon, { icon: "angle-right" }), /*#__PURE__*/
    _jsx("span", {}, void 0, contextLabel)), /*#__PURE__*/

    _jsx("div", { className: "translation-filter" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Untranslated Terms"), /*#__PURE__*/
    _jsx(ToggleButton, {
      checked: showUntranslatedOnly,
      onClick: () => setShowUntranslatedOnly(!showUntranslatedOnly) }))),




    noUntranslatedTerms && showUntranslatedOnly ? /*#__PURE__*/
    _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "info-circle", size: "2x" }), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "There are no untranslated terms"))) : /*#__PURE__*/



    _jsx("ul", { className: "list-group" }, void 0,
    formData.map((data, dataIndex) => /*#__PURE__*/
    _jsx("li", {

      className:
      showUntranslatedOnly && !data.hasUntranslatedValues ?
      'list-group-item hidden' :
      'list-group-item' }, data.key, /*#__PURE__*/


    _jsx("h5", {}, void 0, data.key),

    data.values.map(
    (value, valueIndex) => /*#__PURE__*/
    _jsx("div", { className: "form-group" }, value.locale, /*#__PURE__*/
    _jsx("div", { className: "input-group" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "input-group-addon" }, void 0, value.locale), /*#__PURE__*/
    React.createElement("textarea", _extends({
      className: "form-control",
      rows: 1 },
    register(`formData.${dataIndex}.values.${valueIndex}.value`, {
      required: true
    })))), /*#__PURE__*/


    _jsx(ErrorMessage, {
      errors: errors,
      name: `formData.${dataIndex}.values.${valueIndex}.value`,
      render: () => /*#__PURE__*/
      _jsx("p", { className: "error", role: "alert" }, void 0,
      t('System', 'This field is required')) }))))))), /*#__PURE__*/












    _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
    _jsx(BackButton, { to: "/settings/translations", className: "btn-plain" }),
    context === 'System' && importButton(importTranslations)), /*#__PURE__*/

    _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
    _jsx(I18NLink, { to: "/settings/translations", className: "btn btn-extra-padding btn-default" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel"))), /*#__PURE__*/


    _jsx("button", {
      type: "submit",
      className: "btn btn-extra-padding btn-success save-template",
      disabled: noUntranslatedTerms && showUntranslatedOnly }, void 0, /*#__PURE__*/

    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save"))))))));







};
const container = connector(EditTranslationsFormComponent);
export { container as EditTranslationsForm };